<template>
  <ListSectionCard :href="artikel.url">
    <div class="d-flex">
      <div class="w-25 flex-grow-0 flex-shrink-0">
        <img :src="artikel.previewImage" :alt="artikel.name" />
      </div>
      <div class="ms-2 ms-lg-3 flex-fill">
        <div
          class="highlight-em"
          v-html="artikel.highlighted"
        ></div>
        <div class="mt-2 mt-lg-4">
          <span
            class="rounded-circle me-2 p-2 py-0"
            :class="'product-delivery-' + availability"
          >
          </span>
          <span class="fs-5 fw-bold">{{ formatPrice(artikel.price) }}</span>
        </div>
      </div>
    </div>
  </ListSectionCard>
</template>

<script setup lang="ts">
import {type SearchResultProduct} from "@/ts/components/Types/SearchResult";
import ListSectionCard from "@/components/layout/LiveSearch/ListSectionCard.vue";

interface Props {
  artikel: SearchResultProduct;
}

const props = defineProps<Props>();

function getAvailability(): number {
  const deliveryStatus = customField('deliveryStatus', props);
  if (deliveryStatus) {
    return deliveryStatus;
  }
  return props.artikel.availability;
}

function customField(
    name: string,
    props?: { artikel?: { custom?: any[] } },
): number | undefined {
  const field = props?.artikel?.custom?.find(
      (field) => field.fieldName === name && typeof field.fieldValue === "number",
  );
  return field ? field.fieldValue : undefined;
}

const availability: number = getAvailability();

function formatPrice(price: number): string {
    const priceFormatter = new Intl.NumberFormat(window.etData.langcode, {
        style: "currency",
        currency: window.etData.currencyCode,
    });
    return priceFormatter.format(price);
}
</script>
